// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_RunStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/franquias/run/{id}?depois_de=&limite=
 * (controllers/migration/franquias.php::run).
 *
 * O id da execucao NAO esta aqui: ele vem do segmento da URI, que a rota ja
 * restringe a `(:num)`. O que passa por este contrato sao os dois parametros do
 * POLLING, ambos opcionais.
 *
 * `depois_de` e o cursor: o maior id de log que a tela ja recebeu. Zero (o
 * default) pede a linha do tempo desde o inicio — e o que a tela faz ao abrir
 * uma execucao do historico. Ele e o id AUTO_INCREMENT da tabela, nao um
 * timestamp, de proposito: varias linhas caem no mesmo milissegundo (medido), e
 * um cursor por tempo perderia ou repetiria linhas.
 *
 * `limite` existe para a resposta ter teto. Uma execucao de lote com 35
 * franquias gera ~200 linhas; um erro de laco num dia ruim poderia gerar muito
 * mais, e uma tela que pede "tudo" nao pode derrubar a si mesma. O contrato de
 * resposta devolve `ha_mais` quando o corte aconteceu.
 */
import { registerContract } from './validate'

export interface Migration_RunStatusInput {
depois_de?: number
limite?: number
}

registerContract('Migration_RunStatusInput', {
  depois_de: { type: 'number',  required: false },
  limite:    { type: 'number',  required: false },
})
